<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("orders") }}</h3>
    <div>
      <div class="admin_container">
        <div class="division_main order_page_inner">
          <div style="gap: 15px" class="d-flex mb-3 align-center flex-wrap">
            <custom-input-text
              clearable
              class="user_input no-margin"
              :placeholder="$t('productName')"
              @input="getOrdersByFilter"
              v-model="orderFilter.productName"
              type="text"
            />
            <vue-select
              infinite
              clearable
              @item-resolved="setDepartment"
              @next-page-resolved="
                (data) => setDepartment([...departments, ...data])
              "
              :get-item-promise="
                ({ text, page }) =>
                  $store.dispatch('getDepartments', {
                    page,
                    name: text,
                    limit: 15,
                  })
              "
              :items="departments"
              v-model="orderFilter.departmentId"
              @input="getOrdersByFilter"
              type="text"
              class="user_input no-margin"
            />
            <custom-select
              dense
              class="user_input no-margin mt-1"
              custom-selection
              custom-item
              :value="visibleHeaders"
              @input="setVisibleHeaders"
              multiple
              item-text="text"
              item-value="value"
              :items="headers"
            >
              <template #item="{ attrs, item }">
                <div
                  class="column-setting-title-wrap flex-grow-1"
                  @click="changeColumnSettings(item, attrs)"
                >
                  <base-checkbox
                    class="mr-2"
                    v-model="visibleHeaders"
                    :value="item.value"
                  />
                  <span class="v-list-item__title" style="width: 100%">{{
                    item.text
                  }}</span>
                </div>
              </template>
              <template v-slot:selection="{ item, index }">
                <span v-if="index === 0">{{ $t("columns") }}</span>
              </template>
            </custom-select>
            <custom-date-picker
              clearable
              hide-details
              :max="new Date() || orderFilter.toDate"
              @input="getOrdersByFilter"
              v-model="orderFilter.fromDate"
              label=""
              name="calendar"
              color="#E3EBF3"
              class="data_item user_input data_item_calendar"
              icon="mdi-calendar-month small"
            ></custom-date-picker>
            <custom-date-picker
              :start-day="false"
              hide-details
              :min="orderFilter.fromDate"
              :max="new Date()"
              clearable
              @input="getOrdersByFilter"
              v-model="orderFilter.toDate"
              name="calendar_t"
              color="#E3EBF3"
              class="data_input_tw user_input data_item"
              icon="mdi-calendar-month small"
            ></custom-date-picker>

            <!--              <v-btn-->
            <!--                :disabled="!canMultipleAction"-->
            <!--                class="btn_group_ozl btn_group_ozl_creat btn_buttons"-->
            <!--                color="success"-->
            <!--                dark-->
            <!--                @click="createContractDialogOpenHandler"-->
            <!--              >-->
            <!--                <vue-icon icon="addContract"></vue-icon>-->
            <!--                {{ $t("createContract") }}-->
            <!--              </v-btn>-->
            <v-btn
              :disabled="!canMultipleAction"
              class="btn_group_ozl btn_group_ozl_add btn_buttons"
              color="success"
              dark
              @click="addToContractDialogOpenHandler"
            >
              <vue-icon icon="plusIcon"></vue-icon>
              {{ $t("addToContract") }}
            </v-btn>
            <v-btn
              :disabled="!canMultipleAction"
              class="btn_group_ozl btn_group_ozl_off btn_buttons"
              color="error"
              dark
              @click="terminateOrderItemsConfirmHandler"
            >
              <vue-icon icon="disconIcon"></vue-icon>
              {{ $t("reject") }}
            </v-btn>
          </div>
          <div id="custom__table" class="mobile_simple" style="overflow: auto">
            <table-with-filter
              isEnabledResizeTable
              is-enabled-orderable-table
              @change-header-order="onChangeHeaderOrder"
              @table-header-resized="onChangeSizeHeader"
              :child-key="childKey"
              :headers="filterableHeadersTable"
              :items.sync="orders"
              :open.sync="openedRowKey"
              :options="tableOptions"
              fixed-header
              handlerValue="numb"
              @onException="(e) => setResponseError({ error: e })"
              @update:sort="getOrdersByFilter"
              :page="tableOptions.page"
            >
              <template #header.rejectionReason="{ header }">
                <span class="d-inline-block w-110">{{ header.text }}</span>
              </template>
              <template #item.action="{ item, index }">
                <v-btn
                  v-if="$store.getters.isUserAdmin"
                  @click="$refs.orderHistoryDialog.open(item.id)"
                  class="new_style"
                  :title="$tc('orderHistory', 1)"
                  :data-test="`ozlOrders-order-${index}-reindex-btn`"
                >
                  <vue-icon icon="newTimeIcon"></vue-icon>
                </v-btn>
                <v-tooltip
                  v-if="$store.getters.isUserAdmin"
                  color="#fff"
                  left
                  nudge-right="10"
                  nudge-top="35"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      class="new_style"
                      @click="$refs.deleteProductRef.open(item)"
                      :data-test="`divisionOrders-order-${index}-delete-btn`"
                    >
                      <vue-icon icon="newTrashIcon" />
                    </v-btn>
                  </template>
                  <span>{{ $t("delete") }}</span>
                </v-tooltip>
                <downloader
                  v-if="item['attachmentLink']"
                  :address="item['attachmentLink']"
                  :file-name="item['attachmentName']"
                />
              </template>
              <template #expandBtn="{ item, handlerValue, openHandler }">
                <triangle-btn
                  :active="item.show"
                  :loading="item.loading"
                  @click="
                    () => {
                      openHandler(item);
                      $toggleShowHandler(item.id, item.show);
                    }
                  "
                />
              </template>
              <template #item.state="{ item }">
                <span
                  :style="{ color: item.statusColour }"
                  class="font-weight-bold no-wrap-text"
                  >{{ $t(item.statusCode) }}</span
                >
              </template>
              <template #child.contractNumber="{ child }">
                <h4
                  @click="openDialogView(child)"
                  style="cursor: pointer; text-decoration: underline"
                >
                  {{ child.contractNumber }}
                </h4>
              </template>
              <template #item.receiverDate><span></span></template>
              <template #child.receiverDate="{ child }">{{
                child.actualReceiveDate | fullTimeParse
              }}</template>
              <template #item.sendDate="{ item }">
                {{ item["sendDate"] | fullTimeParse }}
              </template>
              <template #item.numb="{ item, index }">
                <span class="font-weight-bold">{{ item.numb }}</span>
                <ozl-row-check-box
                  :ref="`order-${item.id}`"
                  :childKey="childKey"
                  :item="item"
                  @change="checkOrderHandler"
                  :data-test="`ozlOrders-order-${index}-checkbox`"
                />
              </template>
              <template #item.timeToBeEntered="{ item: { timeToBeEntered } }">{{
                timeToBeEntered | fullTimeParse
              }}</template>
              <template #child.timeToBeEntered="{ child: { timeToBeEntered } }"
                >{{ timeToBeEntered | fullTimeParse }}
              </template>
              <template
                #child.pendingPurchaseDate="{ child: { pendingPurchaseDate } }"
              >
                {{ pendingPurchaseDate | fullTimeParse }}
              </template>
              <template #child.contractDate="{ child: { contractDate } }">{{
                contractDate | fullTimeParse
              }}</template>
              <template
                #child.itemConclusionDate="{ child: { itemConclusionDate } }"
              >
                {{ itemConclusionDate | fullTimeParse }}
              </template>
              <template #child.state="{ child }">
                <span
                  :style="{ color: child.statusColour }"
                  class="font-weight-bold no-wrap-text"
                  >{{ $t(child.state) }}</span
                >
              </template>
              <template #child.count="{ child }"
                ><span class="no-wrap-text"
                  >{{ child.given | numberParse }} /
                  {{ child.count | numberParse }}</span
                ></template
              >
              <template #child.acts="{ child: { id, contractNumber } }">
                <v-btn
                  v-if="contractNumber"
                  class="new_style"
                  @click="$refs.orderItemActFilesDialog.open(id)"
                >
                  <vue-icon icon="newFileEdit" />
                </v-btn>
              </template>
              <template #child.action="{ child, item, itemIndex, index }">
                <div class="ozl-table_btns">
                  <v-btn
                    class="new_style"
                    @click="$refs.orderDialogView.open({ item })"
                    :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-eye-btn`"
                  >
                    <vue-icon icon="newEyeIcon"></vue-icon>
                  </v-btn>
                  <v-tooltip
                    v-if="
                      child.state === PENDING_PURCHASE &&
                      $can($permissions.CONTRACT_ITEM_CREATE)
                    "
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <!--If you add to 'btn_33' element 'disabled' class. it is disabled element  -->
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="$refs.editOrderItemDialog.open(child)"
                        :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-edit-btn`"
                      >
                        <vue-icon icon="newPencilIcon" />
                      </v-btn>
                    </template>
                    <span>{{ $t("edit") }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="child.state === PAPER_EXPECTED_SPECIFICATION"
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="specAcceptHandler(child)"
                        :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-check-btn`"
                      >
                        <vue-icon icon="newCheckIcon"></vue-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("specAccepted") }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      $can($permissions['CONTRACT_CREATE']) &&
                      $can($permissions.CONTRACT_ITEM_CREATE) &&
                      child.state === PENDING_PURCHASE &&
                      child.contractNumber === ''
                    "
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="
                          createContractWithOneProductDialogOpenHandler(child)
                        "
                        :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-contract-btn`"
                      >
                        <vue-icon icon="newTextBoxPlus" />
                      </v-btn>
                    </template>
                    <span>{{ $t("createContract") }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="
                      $can($permissions['CONTRACT_CREATE']) &&
                      $can($permissions['CONTRACT_ITEM_CREATE']) &&
                      child.state === PENDING_PURCHASE &&
                      child.contractNumber === ''
                    "
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="addProductToContractDialogOpenHandler(child)"
                        :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-addToContract-btn`"
                      >
                        <vue-icon icon="newPlusIcon"></vue-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("addToContract") }}</span>
                  </v-tooltip>
                  <v-tooltip
                    v-if="child.state === PENDING_PURCHASE"
                    color="#fff"
                    left
                    nudge-right="10"
                    nudge-top="35"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="new_style"
                        @click="terminateOneOrderItemConfirmHandler(child)"
                        :data-test="`divisionOrders-order-${itemIndex}-orderItem-${index}-cancel-btn`"
                      >
                        <vue-icon icon="newCancelIcon"></vue-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("reject") }}</span>
                  </v-tooltip>
                  <downloader
                    v-if="child['attachmentLink']"
                    :address="child['attachmentLink']"
                    :file-name="child['attachmentFileName']"
                  >
                  </downloader>
                </div>
              </template>
              <template #child.itemNumb="{ item, itemIndex, index, child }">
                <div class="d-flex align-center">
                  <br />
                  <v-checkbox
                    v-if="
                      child.state === PENDING_PURCHASE &&
                      !child['contractNumber']
                    "
                    v-model="child.checked"
                    class="mt-0"
                    hide-details
                    @change="(val) => checkOrderItemHandler(val, child, item)"
                    :data-test="`ozlOrders-order-${itemIndex}-orderItem-${index}-checkbox`"
                  ></v-checkbox>

                  <span class="d-inline-block mr-4 font-weight-bold">{{
                    child["itemNumb"]
                  }}</span>
                </div>
              </template>
              <template #child.sendDate>
                <span></span>
              </template>
              <template #child.guessReceiveDate="{ child }">
                {{ child.itemGuessReceiveDate | dateParse }}
              </template>
              <template #child.rejectionReason="{ child }">
                <downloader
                  v-if="child['rejectedSource']"
                  :address="child['rejectedSource']"
                  :file-name="child.rejectionReason"
                >
                  <template #default="{ downloadFile }">
                    <a
                      class="text-decoration-underline"
                      @click.prevent="downloadFile"
                      >{{ child.rejectionReason }}</a
                    >
                  </template>
                </downloader>
              </template>
              <template #child.unitTypeName="{ child }">{{
                child[`unit_type_name_${$i18n.locale}`]
              }}</template>
              <template #child.productTypeName="{ child }"
                >{{ child[`product_type_${$i18n.locale}`] }}
              </template>
              <template #child.productAttrs="{ child }">
                {{ child.productDescription }}
              </template>
              <template #append:child="{ item }">
                <tr v-if="item.itemsPageCount > 1">
                  <td :colspan="filterableHeadersTable.length">
                    <div class="d-flex">
                      <vue-pagination
                        @input="(page) => onChangeItemPage({ page, item })"
                        :length="item.itemsPageCount"
                        v-model="item.itemsCurrentPage"
                      ></vue-pagination>
                    </div>
                  </td>
                </tr>
              </template>
            </table-with-filter>
            <vue-pagination
              go-to
              v-model="tableOptions.page"
              :length="lastPage"
              @input="changePage"
            />
          </div>
        </div>
      </div>
      <v-dialog
        v-model="dialogTerminate"
        class="user_modal_dialog"
        max-width="600px"
      >
        <validation-observer ref="rejectFormObs" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(terminateOrderItems)">
            <v-card>
              <v-card-title class="mb-5">
                <span class="headline title_modal_user">{{
                  $t("rejectRequest")
                }}</span>
                <v-icon
                  class="info_modal_close"
                  @click="dialogTerminate = false"
                  >mdi-close</v-icon
                >
              </v-card-title>
              <v-card-text class="main_modal">
                <custom-input-text
                  v-model="rejectFormData.reasen"
                  :label="$t('requestRejectionHint')"
                  :rules="`required_custom_message:${$t(
                    'validation.required_reject'
                  )}`"
                  class="col-lg-12 pa-0 user_input"
                ></custom-input-text>
              </v-card-text>
              <v-card-actions class="footer_modal_user">
                <div class="row pt-6">
                  <div class="col-xs-6 pt-0 pb-0 ml-3 file_input_modal_add_ozl">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('file')"
                      rules="required|document|not_empty_file"
                    >
                      <v-file-input
                        v-model="rejectFormData.file"
                        :error-messages="errors[0]"
                        :label="$t('attachFile') + '*'"
                      ></v-file-input>
                    </validation-provider>
                  </div>
                  <div
                    class="d-flex flex-wrap justify-space-around button_modal_add mr-3 mt-3"
                  >
                    <v-btn color="error" dark type="submit"
                      >{{ $t("reject") }}
                    </v-btn>
                  </div>
                </div>
              </v-card-actions>
            </v-card>
          </form>
        </validation-observer>
      </v-dialog>
    </div>
    <order-item-act-files-dialog ref="orderItemActFilesDialog" />
    <edit-order-item-dialog
      ref="editOrderItemDialog"
      @changed="getOrdersByFilter"
    />

    <ozl-order-dialog
      @saved="
        () => {
          clearChecked();
          getOrders();
        }
      "
      ref="ozlOrderFormDialogRef"
    />
    <ozl-order-view-dialog
      @saved="
        () => {
          clearChecked();
          getOrders();
        }
      "
      ref="ozlOrderViewDialogRef"
    ></ozl-order-view-dialog>
    <order-history-dialog ref="orderHistoryDialog"></order-history-dialog>
    <order-dialog-view ref="orderDialogView" />
    <warning-dialog
      v-model="warningDialog"
      @apply="deleteOrderHandler"
      ref="deleteProductRef"
    ></warning-dialog>
  </div>
</template>

<script>
import gridTableMixin from "@/configuration/mixins/gridTableMixin";

const OzlOrderFilter = {
  orderNumber: null,
  productName: null,
  positionState: null,
  contractNumber: null,
  fromDate: null,
  toDate: null,
};
const ITEM_LIMIT = 200;

import triangleBtn from "@/components/table-with-children/triangleBtn";
import ozlRowCheckBox from "@/components/ozl/OzlRowCheckBox";
import { orderItemStatus, TABLES, userTypes } from "@/utils/constants";
import {
  debounce,
  getQueryByKey,
  makerPagination,
  trueSet,
} from "@/utils/pureFunctions";
import Downloader from "@/components/ui/downloader";
import SocketService from "@/services/SocketService";
import { ozlSocketService } from "@/utils/socket/ozl";
import EditOrderItemDialog from "@/components/ozl/EditOrderItemDialog";
import OrderItemActFilesDialog from "@/components/order/OrderItemActFilesDialog";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import VueSelect from "@/components/ui/vue-select/VueSelect";
import BaseCheckbox from "@/components/ui/BaseCheckbox";
import VuePagination from "@/components/ui/vue-pagination/VuePagination";
import OzlOrderDialog from "@/components/ozl/OzlOrderDialog";
import OzlOrderViewDialog from "@/components/ozl/OzlOrderViewDialog";
import OrderHistoryDialog from "@/components/order/OrderHistoryDialog";
import OrderDialogView from "@/components/order-dialog-view/OrderDialogView";
import WarningDialog from "../../../components/ui/prompt/warning-dialog.vue";

export default {
  components: {
    WarningDialog,
    OrderDialogView,
    OrderHistoryDialog,
    OzlOrderViewDialog,
    OzlOrderDialog,
    VuePagination,
    BaseCheckbox,
    VueSelect,
    TableWithFilter,
    OrderItemActFilesDialog,
    EditOrderItemDialog,
    Downloader,
    triangleBtn,
    ozlRowCheckBox,
  },
  data() {
    return {
      warningDialog: false,
      isShowFilter: false,
      childKey: "items",
      openedRowKey: [],
      productTypes: [],
      users: [],
      departments: [],
      orderFilter: {
        ...OzlOrderFilter,
      },
      tableOptions: {
        sortBy: "sendDate",
        sortDirection: false,
        page: 1,
      },
      lastPage: 0,
      currentOrderItem: {
        dialog: true,
        data: {},
      },
      selectedOrderItems: [],
      ...orderItemStatus,
      rejectFormData: {
        reasen: "",
        file: null,
      },

      // dialogs
      dialogTerminate: false,
      contractDialog: false,
      creatingContract: true,
      // lists

      orders: [],
      editedContract: {
        orderItems: [],
      },
    };
  },
  computed: {
    filterableHeadersTable() {
      return this.headers.filter((item) => {
        return this.visibleHeaders.includes(item.value);
      });
    },
    canMultipleAction() {
      return this.selectedOrderItems.length !== 0;
    },
    selectedOrderItemsId() {
      return this.selectedOrderItems.map((item) => item.id);
    },
    orderItemStatus() {
      return Object.keys(orderItemStatus)
        .filter((item) => {
          return (
            item !== orderItemStatus.NEW &&
            item !== orderItemStatus.TO_REVIEW_WAREHOUSE &&
            item !== orderItemStatus.COMPLETED &&
            item !== orderItemStatus.REJECT_ORDER_ITEM
          );
        })
        .map((item) => {
          return {
            name: this.$t(item),
            id: item,
          };
        });
    },
  },
  watch: {
    contractDialog(val) {
      if (!val) {
        const {
          /**
           * @type Object
           * @property {function} reset
           */
          contractFormObs,
        } = this.$refs;
        this.editedContract = {
          supplierId: null,
          conclusionDate: null,
          guessReceiveDate: null,
          supplyType: null,
          orderItems: [],
        };
        if (contractFormObs) contractFormObs.reset();
      }
    },
    dialogTerminate(val) {
      if (!val) {
        const { rejectFormObs } = this.$refs;
        this.rejectFormData = { reasen: "", file: null };
        this.editedContract.orderItems = [];
        if (rejectFormObs) rejectFormObs.reset();
      }
    },
  },
  methods: {
    setVisibleHeaders(headers) {
      this.visibleHeaders = headers;
    },
    setProductType(productTypes) {
      this.productTypes = productTypes;
    },
    setUser(users) {
      this.users = users;
    },
    setDepartment(departments) {
      this.departments = departments;
    },
    setVisibleHeader(headers) {
      this.headers = headers;
    },
    /**
     * @typedef Param {Object}
     * @property page {Number}
     * @property item {Object}
     * @param param {Object<Param>}
     */
    async onChangeItemPage(param) {
      const page = param.page - 1;
      this.showLoading();
      try {
        const {
          data: { data },
        } = await this.$http.get("orders/items-ozl", {
          params: {
            objectId: param.item.id,
            limit: ITEM_LIMIT,
            page,
          },
        });
        param.item.items = data;
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    openDialogView(item) {
      const { ozlOrderViewDialogRef } = this.$refs;
      ozlOrderViewDialogRef.open({ items: [item] || [] });
    },
    async deleteOrderHandler(item) {
      this.showLoading();
      try {
        await this.$http.delete("office/orders/delete", {
          params: { id: item.id },
        });
        await this.getOrders();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    async changeColumnSettings(item, attr) {
      try {
        await this.$store.dispatch("updateColumn", {
          columnName: item.value,
          table: TABLES["Order"].slug,
          visible: !trueSet(attr["aria-selected"]),
        });
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    clearChecked() {
      const orders = [];
      this.selectedOrderItems.forEach((item) => {
        orders.push(item["order_id"]);
      });
      orders.forEach((id) => {
        /**
         *
         * @type Object
         * @property {function} clearState
         */
        const orderRef = this.$refs[`order-${id}`];
        if (orderRef) {
          orderRef.clearState();
        }
      });
      this.selectedOrderItems = [];
    },
    async specAcceptHandler(item) {
      try {
        await this.$http.post("office/order-items/tender", {
          orderItemId: item.id,
        });
        item.state = orderItemStatus.PENDING_PURCHASE;
        item.statusCode = orderItemStatus.PENDING_PURCHASE;
        item.statusColour = "#EFBD17";
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getOrderItem(order) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("getOrderItems", {
            id: order.id,
            type: userTypes["OZL"],
          })
          .then((children) => {
            order.items = children.map((item) => {
              item.checked = false;
              return item;
            });
            resolve();
          })
          .catch((err) => {
            this.setResponseError({ error: err });
            reject(err);
          });
      });
    },
    getOrdersByFilter: debounce(async function () {
      this.showLoading();
      if (this.tableOptions.page !== 1) {
        this.tableOptions.page = 1;
      }
      await this.$router
        .replace({ query: { ...this.tableOptions, ...this.orderFilter } })
        .catch((err) => console.warn(err));
      await this.getOrders();
      this.clearLoading();
    }, 300),
    async changePage(val) {
      const { query: initialQuery } = this.$route;
      this.editedContract = {
        supplierId: null,
        conclusionDate: null,
        guessReceiveDate: null,
        supplyType: null,
        orderItems: [],
      };
      this.selectedOrderItems = [];
      this.showLoading();
      try {
        await this.getOrders();
        await this.$router.replace({
          query: { ...initialQuery, page: val.toString() },
        });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    async getOrders() {
      const params = {
        ...this.tableOptions,
        ...this.orderFilter,
        page: this.tableOptions.page - 1,
        limit: 10,
      };
      try {
        const {
          data: { data, total },
        } = await this.$http.get("/office/orders/list-ozl", { params });

        this.orders = data.map((item) => {
          if (item[this.childKey]) {
            item[this.childKey] = item[this.childKey].map((item) => {
              item.checked = false;
              return item;
            });
          }
          item.itemsCurrentPage = 1;
          item.itemsPageCount = 0;
          if (item.itemCount)
            item.itemsPageCount = makerPagination({
              limit: ITEM_LIMIT,
              total: +item.itemCount,
            }).lastPage;
          item.loading = false;
          item.show = true;
          item.checked = false;
          return item;
        });
        this.lastPage = makerPagination({
          limit: params.limit,
          total,
        }).lastPage;
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async terminateOrderItems() {
      const { file, reasen } = this.rejectFormData;
      this.showLoading();
      const formData = new FormData();
      formData.append("file", file);
      formData.append("reasen", reasen);
      const itemIds = this.editedContract.orderItems.join(",");
      formData.append("itemIds", itemIds);
      try {
        await this.$http.post(`office/order-items/reject-ozl`, formData);
        await this.getOrders();
        this.dialogTerminate = false;
        this.selectedOrderItems = [];
        this.setSuccess({ text: this.$t("successfullyRejected") });
      } catch (e) {
        this.setResponseError({ error: e });
      } finally {
        this.clearLoading();
      }
    },
    checkOrderItemHandler(val, orderItem, parent) {
      /**
       *
       * @type Object
       * @property {function} checkState
       */
      const parentRef = this.$refs[`order-${parent.id}`];
      if (val) {
        this.selectedOrderItems.push({ ...orderItem });
        if (parentRef) parentRef.checkState();
      } else {
        this.selectedOrderItems = this.selectedOrderItems.filter(
          (item) => item.id !== orderItem.id
        );
        const order = this.orders.find((item) => {
          return item.id === orderItem["order_id"];
        });
        if (order && order.checked) {
          order.checked = false;
        }
      }
    },
    checkOrderHandler(val, orderItems) {
      if (val) {
        orderItems.forEach((item) => {
          if (!this.selectedOrderItemsId.includes(item.id)) {
            this.selectedOrderItems.push({ ...item });
          }
        });
      } else {
        this.selectedOrderItems = this.selectedOrderItems.filter((item) => {
          return !orderItems.find((orderItem) => orderItem.id === item.id);
        });
      }
    },
    createContractDialogOpenHandler() {
      const { ozlOrderFormDialogRef } = this.$refs;
      ozlOrderFormDialogRef.open({
        items: this.selectedOrderItems,
        isCreatingContract: true,
      });
    },
    addToContractDialogOpenHandler() {
      const { ozlOrderFormDialogRef } = this.$refs;
      ozlOrderFormDialogRef.open({
        items: this.selectedOrderItems,
        isCreatingContract: false,
      });
    },
    addProductToContractDialogOpenHandler(orderItem) {
      const { ozlOrderFormDialogRef } = this.$refs;
      ozlOrderFormDialogRef.open({
        items: [orderItem],
        isCreatingContract: false,
      });
    },
    createContractWithOneProductDialogOpenHandler(orderItem) {
      const { ozlOrderFormDialogRef } = this.$refs;
      ozlOrderFormDialogRef.open({
        items: [orderItem],
        isCreatingContract: true,
      });
    },
    terminateOneOrderItemConfirmHandler(orderItem) {
      this.editedContract.orderItems.push(orderItem.id);
      this.dialogTerminate = true;
    },
    terminateOrderItemsConfirmHandler() {
      this.editedContract.orderItems = this.selectedOrderItems.map((item) => {
        return item.id;
      });
      this.dialogTerminate = true;
    },
    async connectWebSocket() {
      try {
        const client = await SocketService.promiseConnect();
        client.subscribe("/user/order/reply", (data) => {
          data = JSON.parse(data.body);
          const { eventType } = data;
          if (ozlSocketService[eventType]) {
            ozlSocketService[eventType].call(this, data);
          }
        });
      } catch (e) {
        console.log("ws error", e);
      }
    },
  },
  mixins: [gridTableMixin(TABLES.Order.slug)],
  async created() {
    this.showLoading();
    const { query } = this.$route;
    const tableOptions = getQueryByKey(this.tableOptions, query);
    if (tableOptions.sortDirection)
      tableOptions.sortDirection = trueSet(tableOptions.sortDirection);
    if (tableOptions.page) {
      tableOptions.page = +tableOptions.page;
    }
    this.tableOptions = tableOptions;
    this.orderFilter = getQueryByKey(OzlOrderFilter, query);
    await Promise.all([this.getColumns(), this.getOrders()]);
    this.clearLoading();
    // await this.connectWebSocket()
  },
  beforeDestroy() {
    // SocketService.disconnect()
  },
};
</script>
<style scoped lang="scss">
@media (max-width: 500px) {
  .user_input {
    width: 100%;
  }
  .btn_group_ozl {
    margin: 0 !important;
  }
}
</style>

<style lang="scss">
#custom__table {
  .header_name_filter_table {
    background-color: #ffffff;
  }
  .header_filter_table {
    background-color: #ffffff;
    border: none !important;
    height: 0 !important;
    display: none;
  }
  .table_cover tbody tr td {
    border-bottom: 1px solid #dde6ef !important;
  }
}
</style>
